import { render } from "./HCProfileDetails.vue?vue&type=template&id=3f796116&ts=true"
import script from "./HCProfileDetails.ts?vue&type=script&lang=ts&external"
export * from "./HCProfileDetails.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__